import { render, staticRenderFns } from "./ApprovalPerformance.vue?vue&type=template&id=eddd16fc&scoped=true"
import script from "./ApprovalPerformance.vue?vue&type=script&lang=js"
export * from "./ApprovalPerformance.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPerformance.vue?vue&type=style&index=0&id=eddd16fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddd16fc",
  null
  
)

export default component.exports